(ns app.toolbox.request-modal
  "Modal asking users which tool they'd like us to add to the Storrito
   Toolbox. Collects a free-form description and dispatches the request
   command."
  (:require [clojure.string :as str]))

(defn render
  [state]
  (let [request-text (::request-text state)
        blank? (str/blank? request-text)]
    [:div.py-4.flex.flex-col.items-center.max-w-md.mx-auto
     [:div.w-16.h-16.rounded-full.bg-blue-100.flex.items-center.justify-center.mb-6
      [:i.fas.fa-lightbulb.text-2xl.text-blue-600]]
     [:h3.text-lg.font-semibold.text-gray-900.text-center.mb-2
      "Request a tool"]
     [:p.text-sm.text-gray-500.text-center.mb-6
      "Which tool would you like us to add to the Storrito Toolbox?"]
     [:div.mb-6.w-full
      [:textarea.w-full.border.border-gray-300.rounded-md.p-2.text-sm.text-gray-700.focus:ring-1.focus:ring-blue-500.focus:border-blue-500
       {:rows 4
        :maxlength 1000
        :placeholder "Describe the tool you'd like to see..."
        :value (or request-text "")
        :on {:input [[:store/assoc-in [::request-text] :event/target.value]]}}]]
     [:div.flex.gap-3.justify-end.w-full
      [:button {:class ["px-4" "py-2" "text-sm" "font-medium" "rounded-full"
                        "border" "border-gray-300" "text-gray-700"
                        "bg-white" "hover:bg-gray-50"]
                :on {:click [[:ui/modal-close]]}}
       "Cancel"]
      [:button (cond-> {:class ["px-4" "py-2" "text-sm" "font-medium" "rounded-full"
                                "text-white" "bg-blue-600" "hover:bg-blue-700"
                                "disabled:opacity-50"]
                        :on {:click [[:data/command
                                      {:command/kind :command/toolbox-tool-request
                                       :command/data {:request-text request-text}}]
                                     [:ui/modal-close]]}}
                 blank?
                 (assoc :disabled true))
       "Submit"]]]))

(def modal
  {:modal-id :modals/toolbox-tool-request
   :on-load (fn [_location]
              [[:store/assoc-in [::request-text] nil]])
   :render #'render})
